import * as Yup from "yup";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ERROR = {
  REQUIRED: "Campo Obrigatório",
  POSITIVE: "O valor tem que ser um número positivo",
  EMAIL: "Deve ser um e-mail válido",
  CNPJ: "CNPJ Inválido",
  CPF: "CPF Inválido",
  RG: "RG Inválido",
  TEL: "Telefone Inválido",
  CEL: "Celular Inválido",
  CEP: "CEP Inválido",
  UF: "UF Inválido",
  NIVER: "Data de Nascimento Inválido",
};

const cepValidation = Yup.string()
  .required("CEP obrigatório")
  .test(
    'len',
    'CEP inválido. O CEP deve conter 8 dígitos.',
    (val) => val && String(val).replace(/\D/g, '').length === 8
  );

const baseAddressFields = {
  numero: Yup.number()
    .typeError("Informe o número corretamente")
    .required("Informe o número")
    .integer("Informe o número corretamente"),
  complemento: Yup.string(),
  bairro: Yup.string().required("Bairro obrigatório"),
  cep: cepValidation,
  localidade: Yup.string().required("Cidade obrigatório"),
  uf: Yup.string().required("UF obrigatório"),
  logradouro: Yup.string().required("Logradouro obrigatório"),
};

const adicionalAddressFields = {
  numerotitular_adicional: Yup.number()
    .typeError("Informe o número corretamente")
    .required("Informe o número")
    .integer("Informe o número corretamente"),
  complementotitular_adicional: Yup.string(),
  bairrotitular_adicional: Yup.string().required("Bairro obrigatório"),
  ceptitular_adicional: cepValidation,
  localidadetitular_adicional: Yup.string().required("Cidade obrigatório"),
  uftitular_adicional: Yup.string().required("UF obrigatório"),
  logradourotitular_adicional: Yup.string().required("Logradouro obrigatório"),
  tipotitular_adicional: Yup.string().required("Tipo de endereço é obrigatório"),
};

const comercialAddressFields = {
  numerotitular_comercial: Yup.number()
    .typeError("Informe o número corretamente")
    .required("Informe o número")
    .integer("Informe o número corretamente"),
  complementotitular_comercial: Yup.string(),
  bairrotitular_comercial: Yup.string().required("Bairro obrigatório"),
  ceptitular_comercial: cepValidation, 
  localidadetitular_comercial: Yup.string().required("Cidade obrigatório"),
  uftitular_comercial: Yup.string().required("UF obrigatório"),
  logradourotitular_comercial: Yup.string().required("Logradouro obrigatório"),
  departamentotitular_comercial: Yup.string().required("Departamento obrigatório"),
  empresatitular_comercial: Yup.string().required("Empresa obrigatória"),
};


export const schemaResidencial = Yup.object().shape({
  ...baseAddressFields
});

export const schemaResidencialAlternativo = Yup.object().shape({
  ...baseAddressFields,
  ...adicionalAddressFields
});

export const schemaResidencialComercial = Yup.object().shape({
  ...baseAddressFields,
  ...comercialAddressFields
});

export const schemaResidencialComercialAlternativo = Yup.object().shape({
  ...baseAddressFields,
  ...comercialAddressFields,
  ...adicionalAddressFields
});